import {
  fetchPostTruelayerPublicBankAuthenticationUrl,
  PostTruelayerPublicBankAuthenticationUrlResponse,
} from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';

type PublicBankAuthenticationVariables = {
  stateKey: string;
  providerId: string;
  token: string;
};

export function usePostPublicBankAuthenticationMutation() {
  const { mutateAsync, isPending, data } = useMutation<
    PostTruelayerPublicBankAuthenticationUrlResponse,
    Error,
    PublicBankAuthenticationVariables
  >({
    mutationFn: ({ stateKey, providerId, token }) => {
      return fetchPostTruelayerPublicBankAuthenticationUrl({
        stateKey,
        token,
        providerId,
      });
    },
  });

  return {
    postPublicBankAuth: mutateAsync,
    isPending,
    publicBankAuthData: data,
  };
}
